<template>
  <div class="flex flex-col">
    <div class="p-2 rounded-md bg-red-500">
      <span class="text-gray-300 uppercase">Errors</span>
      <div class="flex flex-col p-2 text-lg max-h-40 overflow-y-auto rounded-md bg-white">
        <span
          v-for="error in errors"
          :key="error">
          {{ error }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: undefined,
  }
}
</script>
